import UI from "./UI";

const NotFound = () => {
  return <UI />;
};

export default NotFound;
